import React, { useState } from 'react'

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const ZoomModalImg = ({ img_src }) => {


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>
            <button type="button" className="position-absolute bottom-0 end-0 p-2 me-3 mb-3 bg-secondary bg-opacity-10 rounded-pill" onClick={handleShow}  >
                <i class="uil uil-search-plus text-secondary"></i>
            </button>

            <Modal show={show} onHide={handleClose} className='bg-blur-sp' centered size="lg">
                <Modal.Body className='position-relative '>
                    <img className='rounded-4 img-info-product-modal-lx border'
                        src={img_src} alt="img-product "
                    />
                    <button type="button" class="position-absolute top-0 start-100 translate-middle p-3 btn-close bg-white rounded-pill" aria-label="Close" onClick={handleClose}></button>
                </Modal.Body>           
            </Modal>
        </>
    )
}

export default ZoomModalImg